import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ganesha-utsava',
  templateUrl: './ganesha-utsava.component.html',
  styleUrls: ['./ganesha-utsava.component.scss']
})
export class GaneshaUtsavaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
